import {Form as AntForm} from 'antd';
import React from 'react';

import Form from '../../../../../components/Form/Form';
import MobileModalForm from '../../../../../components/Form/MobileModalForm';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import helpers from '../../../../../utils/helpers';
import roomToBuildingModalService from './roomToBuildingModalService';

const RoomToBuildingModal = (props) => {
    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const localizedStrings = getLocalizedStrings();

    const {onOk, onCancel} = props;

    const {formContent, title, submitButton, cancelButton, initialValues} =
        roomToBuildingModalService.getModalContent() || {};

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            helpers.runFunction(onOk, values);
        } catch (error) {
            log.error(`BuildingRoomModal - validate failed: ${error}`);
        }
    };

    const setFormField = (name, key) => form.setFieldsValue({[name]: key});

    const handleSelect = async (_, name, option) => {
        const currentValue = form.getFieldValue(name);

        if (currentValue?.value === option.value) return;

        setFormField(name, option.key, option.value);
    };

    const handleChange = () => {};

    if (isMobile) {
        return (
            <MobileModalForm
                form={form}
                formName='room-to-building-mobile'
                title={title}
                closeLabel={localizedStrings[localizationKeys.DC_PAGE_MOBILE_CLOSE_FORM]}
                formFields={formContent}
                initialValues={initialValues}
                onFinish={onFinish}
                onCancel={onCancel}
                submitButton={submitButton}
                cancelButton={cancelButton}
                handleSelect={handleSelect}
                handleChange={handleChange}
            />
        );
    }

    return (
        <Form
            formClassName='room-to-building-form'
            containerClassName='room-to-building-form-content'
            buttonsClassName='room-to-building-form-actions'
            handleSelect={handleSelect}
            closeModal={onCancel}
            initialValues={initialValues}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formContent}
            cancelButton={cancelButton}
            formInstance={form}
            handleChange={handleChange}
        />
    );
};

export default React.memo(RoomToBuildingModal);
